export const strCurrentTabLink = 'purchase-invoice-current-tab-link';
export const strPeriodSearchTypeFavorite = 'purchase-invoice-period-search-type-favorite';
export const strPurchaseCreditKeyLocalStoragePageSize = 'purchase-credit-page-size';
export const strPurchaseCreditKeyLocalStorageSort = 'purchase-credit-sort-favorite';
export const strPurchaseCreditState = 'purchase-credit-state';
export const strPurchaseIngestionFailureKeyLocalStoragePageSize = 'purchase-ingestion-failure-page-size';
export const strPurchaseIngestionFailureKeyLocalStorageSort = 'purchase-ingestion-failure-sort-favorite';
export const strPurchaseIngestionFailureState = 'purchase-ingestion-failure-state';
export const strPurchaseInvoiceKeyLocalStoragePageSize = 'purchase-invoice-page-size';
export const strPurchaseInvoiceKeyLocalStorageSort = 'purchase-invoice-sort-favorite';
export const strPurchaseInvoiceState = 'purchase-invoice-state';
